(() => {
  const items = document.querySelectorAll("[data-role='review-toggler']");
  items.forEach((item) => {
    item.addEventListener("click", (e) => {
      e.preventDefault();
      const parent = item.parentElement;
      const short = parent?.querySelector("[data-role='short-review']");
      const full = parent?.querySelector("[data-role='review']");
      short?.classList.toggle("hidden");
      full?.classList.toggle("hidden");

      if (item.innerHTML == "Читать полностью") {
        item.innerHTML = "Скрыть";
      } else {
        item.innerHTML = "Читать полностью";
      }
    });
  });
})();

const reviewBtns = document.querySelectorAll("[data-role='review-btn']");

reviewBtns.forEach((btn) => {
  btn.addEventListener("click", () => {
    // Define value of btn
    const btnValue = btn.getAttribute("data-value");

    // Set all buttons gray color
    reviewBtns.forEach((item) => {
      item.classList.remove("bg-skb");
      item.classList.remove("text-white");
      item.classList.add("bg-lightGray");
    });

    // set blue color to clicked button
    btn.classList.add("bg-skb");
    btn.classList.add("text-white");

    document.querySelectorAll("[data-role='review-item']").forEach((item) => {
      if (item.getAttribute("data-value") == btnValue) {
        item.classList.remove("hidden");
      } else if (btnValue == "all") {
        item.classList.remove("hidden");
      } else {
        item.classList.add("hidden");
      }
    });
  });
});
